import React from 'react'

interface IProps {
    loading: boolean
}

const LoadingPageComponent: React.FC<IProps> = ({loading}) => {
  return(
    <div className="h-screen bg-gradient-to-br from-gray-900 via-purple-900 to-gray-900 flex flex-col items-center justify-center">
      <img
        src="/censorme.svg"
        alt="CensorMe"
        className="w-48 h-48 mb-8 opacity-90"
      />
      <div><h1 className="text-white text-4xl font-bold">CensorMe</h1></div>
      <br></br>

      <div className="flex items-center gap-3 text-purple-400">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-purple-400"></div>
        <span className="text-lg">{loading ? 'Signing you in…' : 'Loading…'}</span>
      </div>
    </div>
  )
}

export default LoadingPageComponent;